export const svgToSrc = s => {
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(s)))}`;
};
